export default __webpack_public_path__ + "static/media/activity-grey-16px.9c3edeb7.svg";